export default {"src":"/_next/static/media/sint-maarten.2ceeb04d.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};